<template>
    <div class="row pb-2">
        <div :id="`${id}-short-description`" class="col-12" v-if="short_description">
            <div style="white-space: pre-line;" v-html="short_description"></div>
            <span class="show-button show-more-link" @click="showMore">{{ lang('show_more') }}</span>
        </div>
        <div :id="`${id}-long-description`" class="col-12" :class="{'displayNone': !!short_description}">
            <div class="quill-editor ql-container ql-snow" style="border: none; !important;">
                <div class="ql-editor" v-html="description"></div>
            </div>
            <span class="show-button show-less-link" v-if="short_description" @click="showLess">{{ lang('show_less') }}</span>
        </div>
    </div>
</template>

<script>
export default {
name: "np-show-less",
    props: {
        id: {
            default() {
                return Math.random().toString()
            }
        },
        description: '',
    },
    data() {
        return {}
    },
    computed:{
        short_description: function (){
         if(!!this.description) {
             let desc = this.extractTextFromHTML(this.description);
             return desc.length > 100 ? `<p>${desc.split(' ').slice(0, 30).join(' ')}...</p>` : '';
         }
         else return '';
        }
    },
    methods: {
        showMore: function () {
            $(`#${this.id}-short-description`).addClass('displayNone');
            $(`#${this.id}-long-description`).removeClass('displayNone');
        },
        showLess: function () {
            $(`#${this.id}-short-description`).removeClass('displayNone');
            $(`#${this.id}-long-description`).addClass('displayNone');
        },
        extractTextFromHTML: function(htmlString) {
            let resultString = "";

            // Create a temporary element to hold the HTML content
            const tempElement = document.createElement('div');
            tempElement.innerHTML = htmlString;

            // Extract text from elements and maintain hierarchy
            const extractText = (element, currentIndent = 0) => {
                // Check if the element is a text node
                if (element.nodeType === Node.TEXT_NODE) {
                    // Add the text content with appropriate indentation
                    const text = element.textContent.trim();
                    if (text.length > 0) {
                        resultString += ''.repeat(0) + text + '\n';
                    }
                } else {
                    if (element.tagName === 'P') {
                        // Add the text content within <p> tags as a single line
                        resultString += ''.repeat(currentIndent) + element.textContent.trim() + '\n';
                    } else {
                        // Recursively call for child elements
                        const children = element.childNodes;
                        for (const child of children) {
                            extractText(child, currentIndent + 1); // Increase indentation for child elements
                        }
                    }
                }
            };

            // Start extraction from the temp element
            extractText(tempElement);

            return resultString.trim(); // Remove trailing newline
        }
    }
}
</script>

<style scoped>

</style>